import React, { useCallback, useEffect, useRef, useState } from "react";
import "../FiltersSidebar/FiltersSidebar.css";
import { useLocation, useNavigate } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import Select from "react-select";
import { APIUrl, APIUrlToken } from "../../Utils/Utils";
import axios from "axios";
import Loader from "../Loader/Loader";
import DualRangeSlider from "../RangeSlider/DualRangeSlider";
import { toast } from "react-toastify";

const FiltersSidebar = ({
  setLoading,
  loading,
  setIsFiltered,
  filterState,
  setFilterState,
  handleSearchPlayers,
  maxWeight,
  setMaxWeight,
  setSkip,
  playerFilter,
  setPlayerFilter,
  loadedPlayer,
}) => {
  const navigate = useNavigate();
  const [sportsOptions, setSportsOptions] = useState([]);
  const [conferenceOptions, setConferenceOptions] = useState([]);
  const [teamOptions, setTeamOptions] = useState([]);
  const [classOptions, setClassOptions] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearch, setIsSearch] = useState(true);
  const [playerOptions, setPlayerOptions] = useState([]);
  const [positionOptions, setPositionOptions] = useState([]);
  const location = useLocation();
  const { sportIdHome } = location.state || {};
  const sportId = filterState?.sport?.value;
  //get sports
  const getSports = () => {
    // setLoading(true);
    const url = `${APIUrl()}/v1/get_all_sports`;
    axios
      .get(url, {
        headers: {
          "X-API-Key": APIUrlToken(),
        },
      })
      .then((response) => {
        // setLoading(false);
        const data = response?.data || [];
        const formattedSports = data.map((team) => ({
          value: team?.sport_id,
          label: team?.sport_name,
        }));

        setSportsOptions(formattedSports);
      })
      .catch((error) => {
        // setLoading(false);
        console.error("Error fetching teams data:", error);
      });
  };
  //get conferences
  const getConferences = (id) => {
    setLoading(true);
    const url = `${APIUrl()}/v1/conferences_in_sport?sport_id=${id}`;

    axios
      .get(url, {
        headers: {
          "X-API-Key": APIUrlToken(),
        },
      })
      .then((response) => {
        setLoading(false);
        const data = response?.data || [];
        const formattedSports = data.map((team) => ({
          value: team,
          label: team,
        }));

        setConferenceOptions(formattedSports);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching teams data:", error);
      });
  };
  //get teams
  const getAllTeams = () => {
    setLoading(true);
    const url = `${APIUrl()}/v1/teams_by_conference?sport_id=${sportId}&conference=${
      filterState?.conference?.value
    }`;
    const option = {
      method: "GET",
      headers: {
        "X-API-Key": APIUrlToken(),
      },
      url: url,
    };

    axios(option)
      .then((response) => {
        setLoading(false);
        const data = response?.data || [];
        const formattedOptions = data.map((team) => ({
          value: team.team_id,
          label: team.team_name,
        }));

        setTeamOptions(formattedOptions);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching teams data:", error);
      });
  };
  //get players
  const getAllPlayers = () => {
    setLoading(true);
    // setIsSearch(true)
    const url = `${APIUrl()}/v1/players_by_conference?conference=${
      filterState?.conference?.value
    }&skip=1&limit=100`;
    const option = {
      method: "GET",
      headers: {
        "X-API-Key": APIUrlToken(),
      },
      url: url,
    };

    axios(option)
      .then((response) => {
        setLoading(false);
        const data = response?.data?.players?.map((item) => ({
          label: item?.player_name,
          value: item?.player_name,
        }));
        setPlayerOptions(data);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching players data:", error);
      });
  };
  //get Class
  const getPlayerClass = (id) => {
    setLoading(true);
    const url = `${APIUrl()}/v1/unique_player_class_by_sport/${id}`;

    axios
      .get(url, {
        headers: {
          "X-API-Key": APIUrlToken(),
        },
      })
      .then((response) => {
        setLoading(false);
        const data = response?.data?.unique_player_classes || [];
        const formattedSports = data.map((team) => ({
          value: team,
          label: `${team}`,
        }));

        setClassOptions(formattedSports);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching teams data:", error);
      });
  };
  //get position
  const getPlayerPosition = () => {
    setLoading(true);
    const url = `${APIUrl()}/v1/unique_positions_by_sport/${sportId}`;

    axios
      .get(url, {
        headers: {
          "X-API-Key": APIUrlToken(),
        },
      })
      .then((response) => {
        setLoading(false);
        const data = response?.data?.unique_positions || [];
        const formattedSports = data.map((team) => ({
          value: team,
          label: `${team} (${GamePositions[team]})`,
        }));

        setPositionOptions(formattedSports);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching teams data:", error);
      });
  };

  //get Donation Amount
  const handleSearchByWeight = () => {
    // setLoading(true);

    const url = `${APIUrl()}/v1/max_donation_amount`;

    axios
      .get(url, {
        headers: {
          "X-API-Key": APIUrlToken(),
        },
      })
      .then((response) => {
        // setLoading(false);
        setFilterState({
          ...filterState,
          maxAmount: response?.data?.max_donation_amount,
        });
        setMaxWeight(response?.data?.max_donation_amount);
      })
      .catch((error) => {
        // setLoading(false);
        console.error("Error:", error);
      });
  };

  const GamePositions = {
    G: "Guard",
    SG: "Shooting Guard",
    PG: "Point Guard",
    F: "Forward",
    PF: "Power Forward",
    C: "Center",
    ATH: "Athlete",
    QB: "Quarterback",
    RB: "Running Back",
    FB: "Full Back",
    WR: "Wide Receiver",
    TE: "Tight End",
    CB: "Cornerback",
    DE: "Defensive End",
    EDGE: "Edge Rusher",
    S: "Safety",
    DL: "Defensive Line",
    KR: "Kick Returner",
    OT: "Offensive Tackle",
    LB: "Linebacker",
    P: "Punter",
    OL: "Offensive Line",
    DT: "Defensive Tackle",
    DB: "Defensive Back",
    PK: "Place Kicker",
    Center: "Center",
    NT: "Nose Tackle",
    LS: "Long Snapper",
    SF: "Small Forward",
  };

  useEffect(() => {
    getSports();
    handleSearchByWeight();
  }, []);

  useEffect(() => {
    if (sportIdHome) {
      getConferences(sportIdHome);
      getPlayerClass(sportIdHome);
    } else if (filterState?.sport) {
      getConferences(sportId);
      getPlayerClass(sportId);
      setFilterState((prev) => ({
        ...prev,
        conference: "",
        team: "",
        class: "",
        player: "",
        position: "",
      }));
      getAllTeamsSports();
    } else {
      setConferenceOptions([]);
      setPositionOptions([]);
      setTeamOptions([]);
    }
  }, [filterState?.sport, sportIdHome]);

  useEffect(() => {
    if (filterState?.conference) {
      setFilterState({ ...filterState, player: "", class: "", position: "" });
      getAllTeams();
      getAllPlayers();
    } else {
      // setTeamOptions([])
      getAllTeamsSports();
    }
  }, [filterState?.conference]);

  // const handleClearFilters = () => {
  //   setFilterState({
  //     sport: {
  //       value: 2,
  //       label: "Men's College Football"
  //     },
  //     conference: "",
  //     team: "",
  //     class: "",
  //     player: "",
  //     position: "",
  //     minAmount: 0,
  //     maxAmount: Number(maxWeight)
  //   })
  //   setIsFiltered(false)
  //   setSkip(0)
  //   setIsSearch(false)
  //   setPlayerFilter("")
  //   navigate("/");
  //   window.location.reload();

  // }
  const handleClearFilters = () => {
    setFilterState({
      sport: { value: 2, label: "Men's Football" },
      conference: "",
      team: "",
      class: "",
      player: "",
      position: "",
      minAmount: 0,
      maxAmount: Number(maxWeight) || 100,
    });
    setPlayerFilter("");
    setSkip(0);
    setIsFiltered(true); // let Dashboard refetch with defaults
  };

  const handleRangeChange = useCallback(({ min, max }) => {
    setFilterState((prev) => ({
      ...prev,
      minAmount: min,
      maxAmount: max,
    }));
    setIsFiltered(true);
  }, []);

  const getAllTeamsSports = (id) => {
    setLoading(true);
    if (!id) {
      setLoading(false);
      return;
    }
    const url = `${APIUrl()}/v1/get_all_teams_in_sport/${id}`;
    const options = {
      method: "GET",
      headers: {
        "X-API-Key": APIUrlToken(),
      },
    };

    axios(url, options)
      .then((response) => {
        setLoading(false);
        const data = response?.data.teams || [];
        const formattedOptions = data.map((team) => ({
          value: team.team_id,
          label: team.team_name,
          conference: team.conference,
        }));
        setTeamOptions(formattedOptions);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching teams data:", error);
      });
  };

  // ----------------------------------------------------------------------
  const getPositions = (id) => {
    setLoading(true);

    let url = `${APIUrl()}/v1/sports/${id}/positions`;
    if (filterState.team) {
      url += `?team_id=${filterState.team.value}`;
    }

    axios
      .get(url, { headers: { "X-API-Key": APIUrlToken() } })
      .then((res) => {
        const arr = res.data.unique_positions || [];
        setPositionOptions(
          arr.map((pos) => ({
            value: pos,
            label: `${pos} (${GamePositions[pos] || pos})`,
          }))
        );
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  };

  // -------------------------------------------------------------------------
  useEffect(() => {
    if (sportIdHome) {
      getAllTeamsSports(sportIdHome);
    } else if (sportId) {
      getAllTeamsSports(sportId);
    }
  }, [sportIdHome, sportId]);

  useEffect(() => {
    if (sportIdHome) {
      getPositions(sportIdHome);
    } else if (filterState.sport) {
      getPositions(filterState.sport.value);
    } else {
      setPositionOptions([]);
    }
  }, [filterState.sport, filterState.team, sportIdHome]);

  useEffect(() => {
    if (!loadedPlayer) return;

    setFilterState((prev) => {
      const updated = { ...prev };
      if (!prev.class?.value && loadedPlayer.player_class) {
        updated.class = {
          value: loadedPlayer.player_class,
          label: loadedPlayer.player_class,
        };
      }
      if (!prev.position?.value && loadedPlayer.position) {
        updated.position = {
          value: loadedPlayer.position,
          label: `${loadedPlayer.position} (${
            GamePositions[loadedPlayer.position] || loadedPlayer.position
          })`,
        };
      }

      return updated;
    });

    // Mark as “filtered” so that the main useEffect inside Dashboard doesn’t override
    setIsFiltered(true);
  }, [loadedPlayer, setFilterState, setIsFiltered]);

  return (
    <div className="main-filter-sidebar">
      {loading ? <Loader /> : null}

      <div className="search_filter_player_outer">
        {/* <div className="find-loc-head">Search By Player</div> */}
        <div className="find-loc-input-main search_filter_player_outer">
          <input
            type="search"
            className="form-control-input"
            value={playerFilter}
            onChange={(e) => setPlayerFilter(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleSearchPlayers();
            }} // ← add this
            placeholder="Search Athlete"
            name="search"
          />
          <div className="search-icon-player" onClick={handleSearchPlayers}>
            <FaSearch />
          </div>
        </div>
      </div>
      {/* <div className="filter-name">Filter</div> */}
      <div className="filter-text">
        Browse the options below to select your favorite college athletes
      </div>

      <div>
        <div className="find-loc-head">Search By Sports</div>
        <div className="find-loc-input-main">
          <Select
            options={sportsOptions}
            className="form-control-input-select"
            placeholder="Select Sports"
            value={filterState?.sport}
            classNamePrefix="filter_nil"
            onChange={(selectedOption) => {
              setFilterState({ ...filterState, sport: selectedOption });
              setIsFiltered(true);
            }}
          />
        </div>
      </div>
      <div>
        <div className="find-loc-head">Search By Conference</div>
        <div className="find-loc-input-main">
          <Select
            options={conferenceOptions}
            isClearable
            className="form-control-input-select"
            placeholder="Find By Conference"
            value={filterState?.conference}
            classNamePrefix="filter_nil"
            // onChange={(selectedOption) => {
            //   setFilterState({ ...filterState, conference: selectedOption });
            //   setIsFiltered(true);
            // }}
            onChange={(selectedOption) => {
              setFilterState((prev) => ({
                ...prev,
                conference: selectedOption || "",
                // whenever you pick a new conference, clear out the old team
                team: "",
              }));
              setIsFiltered(true);
            }}
          />
        </div>
      </div>
      <div>
        <div className="find-loc-head">Search By Team</div>
        <div className="find-loc-input-main">
          <Select
            options={teamOptions}
            isClearable
            className="form-control-input-select"
            placeholder="Find By Team"
            value={filterState?.team}
            isSearchable
            classNamePrefix="filter_nil"
            // onChange={(selectedOption) => {
            //   setFilterState({ ...filterState, team: selectedOption });
            //   setIsFiltered(true);
            // }}
            // ----------------
            //   onChange={selectedOption => {
            //   if (selectedOption) {
            //     // user picked a team: set both team and its conference
            //     setFilterState(prev => ({
            //       ...prev,
            //       team: selectedOption,
            //       conference: {
            //         value: selectedOption.conference,
            //         label: selectedOption.conference
            //       }
            //     }));
            //   } else {
            //     // user cleared the team dropdown: clear both fields
            //     setFilterState(prev => ({
            //       ...prev,
            //       team: "",
            //       conference: ""
            //     }));
            //   }
            //   setIsFiltered(true);
            // }}
            onChange={(selectedOption) => {
              setFilterState((prev) => {
                // Start by setting the team (or clearing it)
                const updated = {
                  ...prev,
                  team: selectedOption || "",
                };

                // Only back-fill conference when:
                //  • they picked a team -and-
                //  • there was NO conference already selected
                if (
                  selectedOption &&
                  !(prev.conference && prev.conference.value)
                ) {
                  updated.conference = {
                    value: selectedOption.conference,
                    label: selectedOption.conference,
                  };
                }

                return updated;
              });

              setIsFiltered(true);
            }}
          />
        </div>
      </div>
      <div>
        <div className="find-loc-head">Search By Class</div>
        <div className="find-loc-input-main">
          <Select
            options={classOptions}
            isClearable
            className="form-control-input-select"
            placeholder="Find By Class"
            value={filterState?.class}
            isSearchable
            classNamePrefix="filter_nil"
            onChange={(selectedOption) => {
              setFilterState({ ...filterState, class: selectedOption });
              setIsFiltered(true);
            }}
          />
        </div>
      </div>

      {/* <div className="search_filter_player_outer">
        <div className="find-loc-head">Search By Player</div>
        <Select
          options={playerOptions}
          className="form-control-input-select"
          placeholder="Find By Player"
          value={filterState?.player}
          isSearchable
          classNamePrefix="filter_nil"
          onChange={(selectedOption) => setFilterState({ ...filterState, player: selectedOption })} />
        <div className="find-loc-input-main search_filter_player_outer" ref={dropdownRef}>
          <input
            type="search"
            className="form-control-input"
            value={filterState?.player}
            onChange={(e) => { setIsSearch(true); setFilterState({ ...filterState, player: e?.target?.value }) }}
            placeholder="Find by Player"
            name="search"
          />{" "}
         
        </div>
      </div> */}

      <div>
        <div className="find-loc-head">Search By Position</div>
        <div className="find-loc-input-main">
          <Select
            options={positionOptions}
            isClearable
            className="form-control-input-select"
            placeholder="Find By Position"
            value={filterState?.position}
            isSearchable
            classNamePrefix="filter_nil"
            onChange={(selectedOption) => {
              setFilterState({ ...filterState, position: selectedOption });
              setIsFiltered(true);
            }}
          />
        </div>
      </div>

      {/* <div>
        <div className="find-loc-head">Search By Total NIL Amount Received</div>
        <div className="find-loc-input-main">
          {
            // maxWeight ?
            <DualRangeSlider min={0} max={Number(maxWeight) || 100} step={1} onChange={handleRangeChange} filterState={filterState} />
            //  : null
          }
        </div>
      </div> */}

      <div className="search-clr-filter-btn">
        <div className="">
          {/* <button className="search-clr-filter-btn-inputs" onClick={() => handleFilterData(true)}>
            {loading ? "Loading..." : "Search"}
          </button> */}
        </div>
        <div className="">
          <button
            className="search-clr-filter-btn-inputs"
            onClick={handleClearFilters}
          >
            Clear filters
          </button>
        </div>
      </div>
    </div>
  );
};
export default FiltersSidebar;
